// #9: Cross-page, cross-reconnect auto-print de-duplication.
//
// Dashboard.js and Orders.js both subscribe to order_update / payment_confirmed
// and both call printOrder() — so a single order could print twice if both are
// mounted, and payment_confirmed can fire more than once (retried webhook /
// reconnect replay). This tracks which orders have already been AUTO-printed,
// persisted in localStorage so the guard survives both component instances and
// page reloads. Manual reprints intentionally bypass this.

const KEY = 'autoPrintedOrderIds';
const MAX = 200; // keep the list bounded

function read() {
  try {
    const arr = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function hasAutoPrinted(orderId) {
  if (!orderId) return false;
  return read().includes(String(orderId));
}

// Atomically check-and-mark. Returns true if THIS call claimed the print
// (caller should print); false if it was already printed (caller should skip).
export function claimAutoPrint(orderId) {
  if (!orderId) return true; // no id to dedup on — don't block printing
  const id = String(orderId);
  let arr = read();
  if (arr.includes(id)) return false;
  arr.push(id);
  if (arr.length > MAX) arr = arr.slice(arr.length - MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(arr));
  } catch {
    /* storage full / unavailable — fall through and allow the print */
  }
  return true;
}
